
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/cobertures-en-directe",
      function () {
        return require("private-next-pages/3catinfo/cobertures-en-directe/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/cobertures-en-directe"])
      });
    }
  